<template>
  <page :basic="true">
    <sidebar slot="sidebar" />
    <span slot="header">Knowledge Check Response Detail</span>
    <div v-if="!fetching">
      <div class="row">
        <div class="col-sm-6">
          <table class="table table-borderless kc-table">
            <tr>
              <th>Completed By</th>
              <td>{{ model.user_name }}</td>
            </tr>
            <tr>
              <th>Module</th>
              <td>{{ model.module_name }}</td>
            </tr>
          </table>
        </div>
        <div class="col-sm-6">
          <table class="table table-borderless kc-table">
            <tr>
              <th>Completed On</th>
              <td>{{ readableDate(model.completed_date_time) }}</td>
            </tr>
            <tr>
              <th>Score</th>
              <td>{{ score }}</td>
            </tr>
          </table>
        </div>
        <div class="col-sm-12">
          <table class="table table-borderless kc-table">
            <tr>
              <th>Component</th>
              <td>{{ model.component_name }}</td>
            </tr>
            <tr v-if="model.topic_name">
              <th>Topic</th>
              <td>{{ model.topic_name }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="questions p-2">
        <h2>Questions</h2>
        <div
          v-for="(question, idx) in model.questions"
          :key="question.id"
          class="question"
        >
          <question
            v-model="question.answer"
            :question="question"
            :label="idx + 1"
          ></question>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import { readableDate } from '@/helpers'
import { mapState } from 'vuex'
import page from '@/components/templates/page'
import sidebar from '@/components/sidebar'
import reportsApi from '@/api/knowledgechecks/reports'
import question from './question'

export default {
  components: {
    page,
    question,
    sidebar
  },
  data() {
    return {
      fetching: true,
      model: []
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    responseId() {
      return this.$route.params.responseId
    },
    score() {
      const n = Number(this.model.score)
      if (isNaN(n)) {
        return this.model.score
      }
      return n.toFixed(2)
    }
  },
  mounted() {
    this.loadResponse()
  },
  methods: {
    readableDate,
    async loadResponse() {
      this.fetching = true
      const response = await reportsApi.getResponseDetail({
        tenantId: this.organization.id,
        responseId: this.responseId
      })
      this.model = response.data.data
      this.fetching = false
    }
  }
}
</script>

<style lang="scss" scoped>
.kc-table {
  margin-bottom: 0;
  th {
    padding: 5px 5px;
    white-space: nowrap;
  }
  td {
    padding: 5px 5px;
    width: 100%;
  }
}

@media only print {
  .card {
    border: none;
  }

  .kc-table {
    background-color: pink;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/reports/response-detail/index.vue